import React from "react"
import { useAxiosClient } from '../../contexts/Axios'
import { IconButton } from '@material-ui/core'
import { Description as DescriptionIcon } from '@material-ui/icons'
import { downloadFileFromUrl } from "./FileDownloader"
import { useLazyQuery, gql } from '@apollo/client'

const GENERATE_DOWNLOAD_TOKEN = gql`
    query GenerateDownloadToken($resourceType: String!, $id: String!) {
        generateDownloadToken(resourceType: $resourceType, id: $id)
    }
`

export const DownloadFile = props => {
    const { axiosClient } = useAxiosClient()
    return (
        <div key={`fileKey=${props.id}`} style={{textAlign:'center'}}>
            <IconButton style={{padding: 0}} onClick={ event => { event.stopPropagation(); downloadFileFromUrl(axiosClient, props.url ,props.id)}}>
                <DescriptionIcon />
            </IconButton>
        </div>
    )
}

export const GraphQLDownloadFile = ({ resourceType, id }) => {
    const { axiosClient } = useAxiosClient()
    const [generateToken] = useLazyQuery(GENERATE_DOWNLOAD_TOKEN, {
        onCompleted: (data) => {
            if (data?.generateDownloadToken) {
                window.location.assign(`${axiosClient.defaults.baseURL}/download/files/${data.generateDownloadToken}`)
            }
        }
    })
    return (
        <div style={{textAlign: 'center'}}>
            <IconButton style={{padding: 0}} onClick={event => {
                event.stopPropagation()
                generateToken({ variables: { resourceType, id: String(id) } })
            }}>
                <DescriptionIcon />
            </IconButton>
        </div>
    )
}
